import { useState } from "react";
import { useIsInteractiveMode } from "views/components/contexts/InteractiveContext";
import { rowSelectionKey, rowSelectionLabel, selectableFieldsFor, selectedValuesByField } from "./rowSelection";
const useRowSelection = (rows, rowFieldNames, types) => {
  const interactive = useIsInteractiveMode();
  const [selection, setSelection] = useState([]);
  const selectableFields = selectableFieldsFor(rowFieldNames, types, interactive);
  const isSelectable = selectableFields.length > 0;
  const rowKeys = isSelectable ? rows.map((row) => rowSelectionKey(row, rowFieldNames)) : [];
  const selectedKeys = rowKeys.filter((key) => selection.includes(key));
  const allSelected = rowKeys.length > 0 && selectedKeys.length === rowKeys.length;
  const toggleRow = (key) => setSelection((cur) => cur.includes(key) ? cur.filter((curKey) => curKey !== key) : [...cur, key]);
  const selectionFor = (row) => {
    if (!isSelectable) {
      return void 0;
    }
    const key = rowSelectionKey(row, rowFieldNames);
    return {
      checked: selectedKeys.includes(key),
      onChange: () => toggleRow(key),
      label: rowSelectionLabel(row, rowFieldNames)
    };
  };
  return {
    selectAll: isSelectable ? {
      checked: allSelected,
      indeterminate: selectedKeys.length > 0 && !allSelected,
      onChange: () => setSelection(allSelected ? [] : rowKeys)
    } : void 0,
    selectionFor,
    selectedRowsCount: selectedKeys.length,
    selectedValuesByField: selectedValuesByField(rows, rowFieldNames, selectableFields, selectedKeys, types),
    clearSelection: () => setSelection([])
  };
};
export default useRowSelection;
